/* import __COLOCATED_TEMPLATE__ from './manage-fin-identity.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import type IntlService from 'ember-intl/services/intl';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    heading: string;
    description: string;
    imageUrl?: string;
    buttonLabel?: string;
    onClick?: () => void;
    icon?: InterfaceIconName;
  };
}

export default class ManageFinIdentity extends Component<Signature> {
  @service declare router: RouterService;
  @service declare intl: IntlService;

  @action manageFinIdentity() {
    if (this.args.onClick) {
      this.args.onClick();
      return;
    }
    let settingsUrl = this.router.urlFor('apps.app.settings.ai-automation.fin-ai-agent', {
      queryParams: { section: 'personality-settings' },
    });
    safeWindowOpen(settingsUrl, '_blank');
  }

  get icon() {
    return this.args.icon || 'fin';
  }

  get buttonLabel() {
    return (
      this.args.buttonLabel ||
      this.intl.t('standalone.zendesk.deploy.sunshine.fin-identity.manage-button')
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::ManageFinIdentity': typeof ManageFinIdentity;
    'standalone/common/manage-fin-identity': typeof ManageFinIdentity;
  }
}
